/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClientBankAccountsViewModel } from './ClientBankAccountsViewModel';
import {
    ClientBankAccountsViewModelFromJSON,
    ClientBankAccountsViewModelFromJSONTyped,
    ClientBankAccountsViewModelToJSON,
} from './ClientBankAccountsViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfClientBankAccountsViewModel
 */
export interface ResultOfClientBankAccountsViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfClientBankAccountsViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfClientBankAccountsViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfClientBankAccountsViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfClientBankAccountsViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfClientBankAccountsViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfClientBankAccountsViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfClientBankAccountsViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {ClientBankAccountsViewModel}
     * @memberof ResultOfClientBankAccountsViewModel
     */
    data?: ClientBankAccountsViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfClientBankAccountsViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfClientBankAccountsViewModel interface.
 */
export function instanceOfResultOfClientBankAccountsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfClientBankAccountsViewModelFromJSON(json: any): ResultOfClientBankAccountsViewModel {
    return ResultOfClientBankAccountsViewModelFromJSONTyped(json, false);
}

export function ResultOfClientBankAccountsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfClientBankAccountsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ClientBankAccountsViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfClientBankAccountsViewModelToJSON(value?: ResultOfClientBankAccountsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': ClientBankAccountsViewModelToJSON(value.data),
        'Count': value.count,
    };
}

